/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Lock_AriaInputs */



/**
* | output |
* | --- |
* | "Lock" |
*
* @param {Explorer_Info_Lock_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_lock_aria = /** @type {((inputs?: Explorer_Info_Lock_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Lock_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouiller")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sperren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Serratura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Замок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("锁")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ताला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trancar")
	return /** @type {LocalizedString} */ ("Lock")
});